import { useFormikContext } from 'formik';
import { useEffect } from 'react';

export const SubmitOnEveryChange = () => {
  const { values, submitForm } = useFormikContext();

  const dep = JSON.stringify(values);

  useEffect(() => {
    submitForm();
  }, [dep, submitForm]);

  return null;
};
